import type { MarkViewerComponent } from '@blissbook/lib/document/renderer/marks'
import type { LinkMark } from '@blissbook/lib/document/types'
import { Link } from '../../components'

export const LinkMarkViewer: MarkViewerComponent = ({ mark, ...props }) => {
  const { attrs } = mark as LinkMark
  return <Link {...props} {...attrs} />
}
